import type { Company } from '@/api/types';

/**
 * Placeholder, пока дизайнер не отдал реальные SVG.
 * Когда будут — заменить рендер на <img src={`/logos/${company}.svg`} />.
 */
const LETTERS: Record<Company, string> = {
  YANDEX_PRO: 'Я',
  KUPER: 'К',
  SAMOKAT: 'С',
  DOSTAVISTA: 'Д',
  BURGER_KING: 'BK',
  DELIVERY_CLUB: 'DC',
  OTHER: '?',
};

export function CompanyLogo({ company }: { company: Company }) {
  return (
    <div className={`logo-placeholder logo-${company.toLowerCase()}`} aria-label={company}>
      {LETTERS[company]}
    </div>
  );
}

export const COMPANY_NAMES: Record<Company, string> = {
  YANDEX_PRO: 'Яндекс.Про',
  KUPER: 'Купер',
  SAMOKAT: 'Самокат',
  DOSTAVISTA: 'Достависта',
  BURGER_KING: 'Burger King',
  DELIVERY_CLUB: 'Delivery Club',
  OTHER: 'Другое',
};

export const COMPANIES_ORDER: Company[] = [
  'YANDEX_PRO', 'KUPER', 'SAMOKAT', 'DOSTAVISTA',
  'BURGER_KING', 'DELIVERY_CLUB', 'OTHER',
];
